import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";

    module.component('productForecastChart', {
        template: require('./productForecastChartComponent.html'),
        bindings: {
            parameters: "<",
            historicalData: "<",
            statisticalForecast: "<",
            pmForecast: "<",
            rollingForecast: "<",
            showChart: "<",
            isEditable: "<",
            showInMilions: '<'
        },
        controller: ['$scope', 'dtpChartService', 'regressionCalculator', angularServicesNames.$translate, '$timeout', 'FileSaver',
            function(
                this: $TSFixMe,
                $scope: $TSFixMe,
                dtpChartService: $TSFixMe,
                regressionCalculator: $TSFixMe,
                $translate: ng.translate.ITranslateService,
                $timeout: ng.ITimeoutService,
                FileSaver: $TSFixMe
            ) {
                var $ctrl = this;

                function refreshDebounce() {

                    if (angular.isDefined($scope.watchTimeout)) {
                        $timeout.cancel($scope.watchTimeout);
                    }
                    $scope.watchTimeout = $timeout(function () {
                        refreshChart();
                    }, 500);
                }
                $scope.$watch('$ctrl.historicalData', refreshDebounce, true);
                $scope.$watch('$ctrl.statisticalForecast', refreshDebounce, true);
                $scope.$watch('$ctrl.pmForecast', refreshDebounce, true);


                function getMax(array: $TSFixMe) {
                    
                    var max = _.max(_.map(array, function (val: $TSFixMe) { return _.max(val); }));
                    return max * 1.1;
                }

                $ctrl.$onInit = function () {
                    $ctrl.labels = dtpChartService.preparePeriodsAndLabels($ctrl.parameters.historicalDataStart, $ctrl.parameters.forecastEndDate).periods;
                    
                    $ctrl.emptyArray = _.times($ctrl.labels.length, _.constant(null));
                    $ctrl.options = {
                        scales: {
                            yAxes: [{
                                ticks: {
                                    suggestedMin: 0,
                                    suggestedMax: getMax([$ctrl.historicalData, $ctrl.pmForecast, $ctrl.statisticalForecast])
                                }
                            }]
                        }
                    };
                }

                $scope.$on('chart-create', (e: $TSFixMe, chartInstance: $TSFixMe) => {
                    $ctrl.chartInstance = chartInstance;
                });

                $ctrl.exportChart = (event: $TSFixMe) => {
                    var canvas = $ctrl.chartInstance.chart.canvas;
                    canvas.toBlob(function (blob: $TSFixMe) {
                        FileSaver.saveAs(blob, 'wykres.png');
                    }, 'image/png', 1);
                }

                $scope.$on('LanguageChanged', () => resetChartTranslations());
                resetChartTranslations();

                function resetChartTranslations() {
                    $translate(['FORECAST.CHART.PM_FORECAST', 'FORECAST.CHART.STATISTICAL_FORECAST', 'FORECAST.CHART.LINEAR_FORECAST', 'FORECAST.CHART.ROLLING_FORECAST'])
                        .then(function (translations: $TSFixMe) {
                            $ctrl.datasetOverride = [
                                {
                                    label: translations["FORECAST.CHART.PM_FORECAST"],
                                    borderColor: "rgba(235,154,110, 1)",
                                    backgroundColor: "rgba(235,154,110, 1)"
                                },
                                {
                                    label: translations["FORECAST.CHART.STATISTICAL_FORECAST"],
                                    borderColor: "rgba(100,181,246, 1)",
                                    backgroundColor: "rgba(100,181,246, 1)"
                                },
                                {
                                    label: translations["FORECAST.CHART.LINEAR_FORECAST"],
                                    borderColor: "rgba(128, 196, 194, 1)",
                                    backgroundColor: "rgba(128, 196, 194, 1)"
                                },
                                {
                                    label: translations["FORECAST.CHART.ROLLING_FORECAST"],
                                }
                            ];

                        });
                }

                function refreshChart() {


                    if (angular.isUndefinedOrNull($ctrl.pmForecast)

                        && angular.isUndefinedOrNull($ctrl.statisticalForecast)

                        && angular.isUndefinedOrNull($ctrl.historicalData))
                        return;

                    var statisticalForecast = null;
                    $ctrl.forecastChartData = null;

                    if (!angular.isUndefinedOrNull($ctrl.pmForecast)) {
                        var missingSize = $ctrl.labels.length - $ctrl.historicalData.length - $ctrl.pmForecast.length;
                        
                        $ctrl.forecastChartData = $ctrl.historicalData.concat(_.times(missingSize, _.constant(null))).concat($ctrl.pmForecast);
                    } else {
                        $ctrl.forecastChartData = $ctrl.historicalData;
                    }

                    if (!angular.isUndefinedOrNull($ctrl.statisticalForecast)) {
                        
                        statisticalForecast = _.times($ctrl.labels.length - $ctrl.statisticalForecast.length, _.constant(null)).concat($ctrl.statisticalForecast);
                    } else {
                        statisticalForecast = $ctrl.emptyArray;
                    }

                    prepareAndDisplayChartData(statisticalForecast);

                    if ($ctrl.isCalculateMkshr) {
                        // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 2.
                        $ctrl.options.scales.yAxes[0].ticks.suggestedMax = getMax($ctrl.forecastChartData, $ctrl.itemsToDisplay);
                    }
                }

                function prepareAndDisplayChartData(statisticalForecast: $TSFixMe) {
                    let itemsToDisplay = [$ctrl.forecastChartData, statisticalForecast];
                    if ($ctrl.historicalData.length > 0) {
                        
                        var linearRegression = regressionCalculator.calculateLinear($ctrl.historicalData, _.range($ctrl.labels.length));
                        itemsToDisplay.push(linearRegression);
                    }

                    if (angular.isDefined($ctrl.rollingForecast)) {
                        
                        itemsToDisplay.push(_.times($ctrl.labels.length - $ctrl.rollingForecast.length, _.constant(null)).concat($ctrl.rollingForecast));
                    }

                    $ctrl.itemsToDisplay = itemsToDisplay;
                }

            }]
    })

})(angular.module('topline.modules'));